import React from 'react'
import styles from './styles.module.scss'
import { useShoppingCart } from '@/src/context/shopping-cart/shopping-cart-context'
import PriceSummary from '../price-summary/price-summary'
import ShoppingCartHead from '../shopping-cart-head/shopping-cart-head'
import ShoppingCartItems from '../shopping-cart-items/shopping-cart-items'

interface Props {
    showContinueButton?: boolean
}

export default function FullShoppingCart({ showContinueButton }: Props) {
    const { shoppingCart } = useShoppingCart()

    const hasItems = shoppingCart?.items && shoppingCart?.items.length > 0

    return (
        <div className={styles.cart}>
            <ShoppingCartHead />
            <ShoppingCartItems />
            {
                hasItems &&
                <PriceSummary showContinueButton={showContinueButton} />
            }
        </div>
    )
}
